import React from 'react';
import useStyle from './cartHeader.style';

interface CartHeaderProps {
  isPanierPage?: boolean;
}

export const CartHeader = ({ isPanierPage = false }: CartHeaderProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <p>
        Description <span className={classes.qtd}>produit</span>
      </p>
      {isPanierPage && <p className={classes.qtd}>Quantité</p>}
      <p>Sous-Total</p>
    </div>
  );
};
